import { render, staticRenderFns } from "./ds-manager-editor.vue?vue&type=template&id=59f8eb00"
import script from "./ds-manager-editor.vue?vue&type=script&lang=js"
export * from "./ds-manager-editor.vue?vue&type=script&lang=js"
import style0 from "./ds-manager-editor.vue?vue&type=style&index=0&id=59f8eb00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ds-manager-editor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports